import React from 'react';
import Layout from '../Layout';

const FAButtonView = (props) => (
  <Layout {...props} type="FAButtonView"/>
)
export default FAButtonView;



// WEBPACK FOOTER //
// ./src/contents/editorPreview/layout/components/Content/FAButtonView.js